import { format, secondsToMilliseconds } from 'date-fns'
import { useRunUserReportJob, useUserReport } from '../../../queries/userReport'
import Button from '../../core/Button/Button'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Flex } from '../../core/Flex'
import Text from '../../core/Text/Text'
import { useDownloadUsers } from '../hooks'
import { HoldersDropdown } from './HoldersDropdown'

export const UserReport = () => {
  const userReportQuery = useUserReport({ refetchInterval: secondsToMilliseconds(30) })
  const runUserReportJob = useRunUserReportJob()
  const { label, isDone, handleClick } = useDownloadUsers()
  return (
    <>
      <Text size="20">User Report</Text>
      {userReportQuery.isLoading && <CenteredLoadingAnimation />}
      {userReportQuery.data && (
        <>
          <Flex css={{ gap: '4px', alignItems: 'baseline' }}>
            <Text size="14">A seven day user report history from the last generation time</Text>
            <Text size="12" type="secondary">
              (last generated on {format(new Date(userReportQuery.data.createdAt), 'MM/dd/yyy')})
            </Text>
          </Flex>
          <Flex css={{ gap: '8px', marginTop: '8px', marginBottom: '16px' }}>
            <a href={userReportQuery.data.url}>
              <Button type="dark" big>
                Download report
              </Button>
            </a>
            <Button
              type="outlined"
              big
              disabled={userReportQuery.data.isJobRunning}
              onClick={() => runUserReportJob.mutate()}
            >
              {userReportQuery.data.isJobRunning
                ? 'New report is generating'
                : 'Generate new report'}
            </Button>
            <Button type="dark" big onClick={handleClick} disabled={!isDone}>
              {label}
            </Button>
            <HoldersDropdown />
          </Flex>
        </>
      )}
    </>
  )
}
